<app-base-modal [showClose]="showClose" (closeCross)="onCloseModal()">
  <ng-container modal-body-content>
    <div class="learning-video-modal-content">
      @if (videoUrl) {
        <app-video-player
          [videoUrl]="videoUrl"
          [videoTitle]="videoTitle || ''"
          [controls]="true"
          [autoplay]="false"
          [preload]="'metadata'"
          [width]="'100%'"
          [height]="'100%'"
        >
        </app-video-player>
      }
      @if (!videoUrl) {
        <div class="video-error-placeholder">
          <p class="error-message">{{ 'LEARNING.VIDEO_ERROR_MESSAGE' | translate }}</p>
        </div>
      }
    </div>
  </ng-container>
</app-base-modal>
